import { useUserSession } from '#imports';
import { defineNuxtRouteMiddleware, navigateTo } from '#app/composables/router';
import { useNuxtApp } from '#app/nuxt';

export default defineNuxtRouteMiddleware(async () => {
  const nuxtApp = useNuxtApp();
  const { fetch, loggedIn } = useUserSession();

  // NOTE: ハイドレーション中は SSR で取得したログイン状態を引き継いでいるので取り直さない。
  //       取り直すと、未ログインの訪問者にも空のセッション Cookie が発行される
  if (!nuxtApp.isHydrating) {
    await fetch();
  }

  if (!loggedIn.value) {
    return navigateTo('/public/healthyRecipe/login');
  }
});
